import { render, staticRenderFns } from "./BaseSlidePanel.vue?vue&type=template&id=733b2050&scoped=true"
import script from "./BaseSlidePanel.vue?vue&type=script&lang=js"
export * from "./BaseSlidePanel.vue?vue&type=script&lang=js"
import style0 from "./BaseSlidePanel.vue?vue&type=style&index=0&id=733b2050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733b2050",
  null
  
)

export default component.exports